module.exports = __webpack_public_path__ + "img/head.cfd4b538.gif";